var map = {
	"./direct.png": 7644,
	"./excel.png": 5584,
	"./facebook.png": 8900,
	"./fixdigital.png": 348,
	"./google-ads.png": 4713,
	"./hand.png": 6418,
	"./instagram.png": 4794,
	"./linkedin.png": 1654,
	"./logo-w.png": 6226,
	"./logo-w@2x.png": 9037,
	"./logo.png": 6949,
	"./logo@2x.png": 3149,
	"./newsletter.png": 8621,
	"./outbrain.png": 6594,
	"./phone.png": 9156,
	"./print.png": 6950,
	"./radio.png": 6111,
	"./tiktok.png": 9269,
	"./tv.png": 424,
	"./whatsapp.png": 6656,
	"./youtube.png": 9844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2715;